import { Router } from 'vue-router'
import { useAuthStore } from '../stores/auth'

export function setupRouterGuards(router: Router) {
  router.beforeEach(async (to, _from, next) => {
    const authStore = useAuthStore()

    // Ensure auth is initialized
    if (!authStore.initialized) {
      await authStore.initialize()
    }

    // Protect dashboard routes - require authentication
    const protectedRoutes = ['/dashboard', '/agents', '/domains', '/tickets', '/settings', '/admin']
    const isProtectedRoute = protectedRoutes.some(route => to.path.startsWith(route))

    if (isProtectedRoute) {
      if (!authStore.isAuthenticated) {
        // Not authenticated, redirect to login
        next('/login')
        return
      }

      // Check super admin requirement
      if (to.path.startsWith('/admin')) {
        if (authStore.user?.role !== 'super_admin') {
          next('/dashboard')
          return
        }
      }
    }

    // Redirect authenticated users away from login/register pages
    if ((to.path === '/login' || to.path === '/register') && authStore.isAuthenticated) {
      next('/dashboard')
      return
    }

    // Allow access
    next()
  })
}